module.exports = __webpack_public_path__ + "img/gsgc2903_2.8331fbdc.svg";